import { Attributes, ValueObject, NeoModel } from "@singularsystems/neo-core";

@NeoModel
export default class ProcessingFileLookup extends ValueObject {
    
    public processingFileId: number = 0;

    public fileName: string = "";

    public isProcessedInd: boolean = false;

    @Attributes.Date()
    public createdOn: Date | null = null;
}